import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getPayoutsFeeEstimate } from 'services/PayoutsService'
import { QueryMetaType } from 'types/reactQuery'
import { PayoutRequest } from 'types/unifiedPayouts/unifiedPayouts'
import { UnifiedPayoutsV2Request } from 'types/unifiedPayouts/unifiedPayoutsV2'

export interface PayoutsFeeEstimateParams {
  request: UnifiedPayoutsV2Request
  isEnabled?: boolean
}

export const usePayoutsFeeEstimateQuery = (options: PayoutsFeeEstimateParams) => {
  const { request, isEnabled = false } = options || {}

  const meta: QueryMetaType = {
    errorAdditionalData: { request },
  }

  return useQuery({
    queryKey: reactQueryKeys.payoutsFeeEstimate(request),
    queryFn: () => getPayoutsFeeEstimate(request),
    enabled: isEnabled && !!options,
    meta,
  })
}
